import {
  BodyText,
  Box,
  DetailText,
  Flex,
  Strong,
} from '@utilitywarehouse/hearth-react';
import { ReactNode } from 'react';

import {
  BreakdownButtonConfig,
  ServiceTile,
  getServiceTileId,
} from '@components/ServiceTile';

import { BroadbandTileDiscount } from '../types';
import './styles.scss';

interface BroadbandTileProps {
  breakdown: BreakdownButtonConfig;
  description: ReactNode;
  discount?: BroadbandTileDiscount;
  contractLength?: number;
  isSelected: boolean;
  price: string;
  annotation?: ReactNode;
  serviceName: string;
  testId?: string;
  value: string;
}

interface PriceProps {
  annotation?: ReactNode;
  contractLength?: number;
  discount?: BroadbandTileDiscount;
  price: string;
  serviceName: string;
}

const Price = ({
  annotation,
  contractLength,
  discount,
  price,
  serviceName,
}: PriceProps) => {
  const priceId = getServiceTileId(serviceName, 'price');

  if (discount) {
    const { price: discountedPrice, duration } = discount;

    return (
      <Box className="service-tile__price">
        <Flex alignItems="baseline" spacing="sm">
          <BodyText size="md" className="service-tile__discounted-price">
            {price}
          </BodyText>
          <DetailText id={priceId} size="3xl" color="valid">
            {discountedPrice}
          </DetailText>
          <BodyText size="sm">for {duration} months</BodyText>
        </Flex>
        <BodyText data-testid="discount-annotation" size="sm">
          Then <Strong>{price}</Strong> for {discount.contractLength - duration}{' '}
          months
        </BodyText>
        {annotation && (
          <BodyText size="sm" color="secondary" marginTop="50">
            {annotation}
          </BodyText>
        )}
      </Box>
    );
  }

  return (
    <Box className="service-tile__price">
      <Flex alignItems="baseline" spacing="sm">
        <DetailText id={priceId} size="3xl">
          {price}
        </DetailText>
        <BodyText size="sm" as="span">
          a month
        </BodyText>
      </Flex>
      {contractLength && (
        <BodyText size="sm">{contractLength} months contract</BodyText>
      )}
      {annotation && (
        <BodyText size="sm" color="secondary" marginTop="50">
          {annotation}
        </BodyText>
      )}
    </Box>
  );
};

const BroadbandTile = ({
  annotation,
  breakdown,
  contractLength,
  description,
  discount,
  isSelected,
  price,
  serviceName,
  testId,
  value,
}: BroadbandTileProps) => (
  <ServiceTile
    buttonText="plan"
    className="broadband"
    description={description}
    gap="lg"
    isSelected={isSelected}
    serviceName={serviceName}
    testId={testId}
    value={value}
    breakdown={breakdown}
  >
    <Price
      annotation={annotation}
      contractLength={contractLength}
      discount={discount}
      price={price}
      serviceName={serviceName}
    />
  </ServiceTile>
);

export { BroadbandTile };
